// removed by extract-text-webpack-plugin
module.exports = {"root":"_1hFbd","openDetail":"_1oPsK","tableContainer":"_ZwtPt","small":"_3VUs2","mobileList":"_350ZG","listDate":"_3LFAR","packageDetails":"_3_Q4m","name":"_3KYsZ","row":"_1ucGY"};


//////////////////
// WEBPACK FOOTER
// ./app/containers/Account/children/AccountSubscriptions/components/AccountHistoricalPurchases/AccountHistoricalPurchases.scss
// module id = 895
// module chunks = 34